/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Approved1Inputs */

const en_coinvestments_prospects_approved1 = /** @type {(inputs: Coinvestments_Prospects_Approved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospect Approved`)
};

/**
* | output |
* | --- |
* | "Prospect Approved" |
*
* @param {Coinvestments_Prospects_Approved1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_approved1 = /** @type {((inputs?: Coinvestments_Prospects_Approved1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Approved1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_approved1(inputs)
});
export { coinvestments_prospects_approved1 as "coInvestments_prospects_approved" }